import { render, staticRenderFns } from "./blindPage.vue?vue&type=template&id=3d497502&scoped=true&"
import script from "./blindPage.vue?vue&type=script&lang=js&"
export * from "./blindPage.vue?vue&type=script&lang=js&"
import style0 from "./blindPage.vue?vue&type=style&index=0&id=3d497502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d497502",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d497502')) {
      api.createRecord('3d497502', component.options)
    } else {
      api.reload('3d497502', component.options)
    }
    module.hot.accept("./blindPage.vue?vue&type=template&id=3d497502&scoped=true&", function () {
      api.rerender('3d497502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/blindPage.vue"
export default component.exports